import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiLock, FiCheckCircle, FiAlertCircle} = FiIcons;

/**
 * Shared ApprovalGate component (docs/screen-capability-and-layout-spec.md).
 * Represents an AI-produced change awaiting explicit human sign-off.
 * Reusable visual language across Website, Plans, Inbox replies, and Flows.
 */
export default function ApprovalGate({
  status = 'draft',
  onApprove,
  onRevoke,
  title,
  description,
  approveLabel = 'Approve & publish',
  revokeLabel = 'Return to draft',
  disabled = false,
  compact = false
}) {
  const isApproved = status === 'published' || status === 'approved' || status === 'done';

  const defaultTitle = isApproved ? 'Approval passed' : 'Approval required';
  const defaultDesc = isApproved
    ? 'Signed off by workspace owner — live and visible.'
    : 'This AI-produced change cannot go live until a workspace owner approves it.';

  return (
    <div className={`approval-gate-banner ${isApproved ? 'approved' : 'pending'} ${compact ? 'compact' : ''}`}>
      <div className="gate-status-indicator">
        <SafeIcon
          icon={isApproved ? FiCheckCircle : FiLock}
          className={isApproved ? 'icon-approved' : 'icon-pending'}
        />
      </div>

      <div className="gate-content">
        <div className="gate-title-row">
          <b>{title || defaultTitle}</b>
          <span className={`status ${status}`}>{status}</span>
        </div>
        <p className="gate-description">{description || defaultDesc}</p>
      </div>

      <div className="gate-actions">
        {isApproved ? (
          onRevoke && (
            <button
              type="button"
              className="button secondary compact"
              onClick={onRevoke}
              disabled={disabled}
              title="Revert to draft for editing"
            >
              <SafeIcon icon={FiLock} />
              {revokeLabel}
            </button>
          )
        ) : (
          onApprove && (
            <button
              type="button"
              className="button primary compact"
              onClick={onApprove}
              disabled={disabled}
              title="Explicitly sign off and publish"
            >
              <SafeIcon icon={FiCheckCircle} />
              {approveLabel}
            </button>
          )
        )}
      </div>
    </div>
  );
}
